import * as schemaTasks from "~/schemas/schema.tasks.jsx";
import * as schemaTeams from "~/schemas/schema.teams.jsx";
import {
  ADD_TEAM,
  EDIT_TEAM,
  LOAD_TEAM,
  LOAD_TEAMS,
  LOAD_REQUEST,
  LOAD_FAILURE,
  DELETE_TEAM_FROM_EVENT_STREAM,
  CREATE_TEAM_FROM_EVENT_STREAM,
  UPDATE_TEAM_FROM_EVENT_STREAM,
  DELETE_TEAM,
  FETCH_TEAM_TASKS_ERROR,
  FETCH_TEAM_TASKS_SUCCESS,
  FETCH_TEAM_TASKS_LOADING,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const addTeam = (attributes) => {
  return {
    types: [LOAD_REQUEST, ADD_TEAM, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/teams`,
        method: "post",
        body: attributes,
      }),
    payload: { attributes },
  };
};

export const editTeam = (team_id, attributes) => {
  return {
    types: [LOAD_REQUEST, EDIT_TEAM, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/teams/${team_id}`,
        method: "put",
        body: attributes,
      }),
    payload: { id: team_id, attributes, schema: { single: schemaTeams.team } },
  };
};

export const deleteTeam = (id) => {
  return {
    types: [LOAD_REQUEST, DELETE_TEAM, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/teams/${id}`,
        method: "delete",
      }),
    payload: { id },
  };
};

export const loadTeam = (team_id) => {
  return {
    types: [LOAD_REQUEST, LOAD_TEAM, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/teams/${team_id}`,
      }),
    payload: { team_id },
  };
};

export const loadTeams = () => {
  return {
    types: [LOAD_REQUEST, LOAD_TEAMS, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/teams`,
      }),
  };
};

export const getTeamTasks = (team_id) => {
  return {
    types: [FETCH_TEAM_TASKS_LOADING, FETCH_TEAM_TASKS_SUCCESS, FETCH_TEAM_TASKS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/teams/${team_id}/tasks`,
      }),
    payload: {
      team_id,
      schema: {
        tasks: schemaTasks.arrayOfTasks,
        related: {
          Task: schemaTasks.arrayOfTasks,
        },
      },
    },
  };
};

export const deleteTeamFromEventStream = (id) => {
  return {
    type: DELETE_TEAM_FROM_EVENT_STREAM,
    id,
  };
};

export const createTeamFromEventStream = (data) => {
  return {
    type: CREATE_TEAM_FROM_EVENT_STREAM,
    response: data,
    schema: schemaTeams.team,
  };
};

export const updateTeamFromEventStream = (data) => {
  return {
    type: UPDATE_TEAM_FROM_EVENT_STREAM,
    response: data,
    schema: schemaTeams.team,
  };
};
